import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { FaSearch, FaTimes } from 'react-icons/fa';

const SearchBox = () => {
  const navigate = useNavigate();
  const { keyword: urlKeyword } = useParams();
  const [keyword, setKeyword] = useState(urlKeyword || '');
  const [open, setOpen] = useState(false);

  const submitHandler = (e) => {
    e.preventDefault();
    if (keyword.trim()) {
      setKeyword('');
      setOpen(false);
      navigate(`/search/${keyword}`);
    } else {
      navigate('/');
    }
  };

  if (!open) {
    return (
      <button
        type="button"
        aria-label="Search artworks"
        className="nav-icon-btn"
        onClick={() => setOpen(true)}
      >
        <FaSearch />
      </button>
    );
  }

  return (
    <Form
      onSubmit={submitHandler}
      className="d-flex align-items-center navbar-search"
    >
      <FaSearch className="navbar-search-icon" />
      <Form.Control
        autoFocus
        type="text"
        name="q"
        onChange={(e) => setKeyword(e.target.value)}
        value={keyword}
        placeholder="Search artworks…"
        className="navbar-search-input"
      />
      <button
        type="button"
        aria-label="Close search"
        className="nav-icon-btn"
        onClick={() => {
          setOpen(false);
          setKeyword('');
        }}
      >
        <FaTimes />
      </button>
    </Form>
  );
};

export default SearchBox;
